const FULL_FAQ_SELECTOR = '.custom-faq-section, .accordion accordion-custom';

class SodiiFaqLink extends HTMLElement {
  /** @type {HTMLAnchorElement | null} */
  #link = null;

  connectedCallback() {
    this.#link = this.querySelector('[data-sodii-faq-link]');
    if (!this.#link) return;

    this.#link.addEventListener('click', this.#handleClick);
    document.addEventListener('shopify:section:load', this.#handleSectionLoad);

    const target = this.#ensureTarget();
    if (target && window.location.hash === this.#link.hash) {
      requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));
    }
  }

  disconnectedCallback() {
    this.#link?.removeEventListener('click', this.#handleClick);
    document.removeEventListener('shopify:section:load', this.#handleSectionLoad);
  }

  #handleClick = (event) => {
    const target = this.#ensureTarget();
    if (!target || !this.#link) {
      event.preventDefault();
      return;
    }

    event.preventDefault();
    window.history.pushState(null, '', this.#link.hash);
    target.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start',
    });
  };

  #handleSectionLoad = () => {
    this.#ensureTarget();
  };

  #ensureTarget() {
    const targetId = this.#targetId();
    if (!targetId) return null;

    const existingTarget = document.getElementById(targetId);
    if (existingTarget) return existingTarget;

    const faqSection = this.#findFaqSection();
    if (!faqSection) return null;

    const marker = document.createElement('span');
    marker.id = targetId;
    marker.className = 'sodii-faq-closing__scroll-target';
    marker.setAttribute('aria-hidden', 'true');
    faqSection.prepend(marker);

    return marker;
  }

  #targetId() {
    if (!this.#link?.hash) return '';

    try {
      return decodeURIComponent(this.#link.hash.slice(1));
    } catch {
      return this.#link.hash.slice(1);
    }
  }

  #findFaqSection() {
    const sourceSection = this.closest('.shopify-section');
    const pageSections = Array.from(document.querySelectorAll('.shopify-section'));
    const sourceIndex = pageSections.indexOf(sourceSection);
    const faqSections = pageSections.filter(
      (section) => section !== sourceSection && section.querySelector(FULL_FAQ_SELECTOR)
    );

    return (
      faqSections.find((section) => pageSections.indexOf(section) > sourceIndex) ?? faqSections.at(-1) ?? null
    );
  }
}

if (!customElements.get('sodii-faq-link')) {
  customElements.define('sodii-faq-link', SodiiFaqLink);
}
